import React from 'react';
import SearchIcon from '@material-ui/icons/Search';

import classes from './NavigationItems.module.css';
import NavigationItem from './NavigationItem/NavigationItem';
import UserButton from "../../UI/UserButton/UserButton";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import MiscSearchButton from "../../UI/MiscSearchButton/MiscSearchButton";
import NotificationsButton from "../../UI/NotificationsButton/NotificationsButton";

const navigationItems = ( props ) => (
    <>
        <div className={classes.LeftNav}>
            <div className={classes.DiceWrapper}>
                <a href="https://patternlanguageforgamedesign.com">
                    <img className={classes.HomeImage} src="https://patternlanguageforgamedesign.com/PatternLibrary/Images/Die.png" alt="Return to Pattern Language for Game Design homepage."/>
                </a>
                <div className={classes.SiteTitle}>Pattern Language for Game Design</div>
            </div>

            <ul className={classes.NavigationItems}>
                <NavigationItem link="/PatternLibraryApp/PatternLibrary" exact sideDrawerClosed={props.sideDrawerClosed}>
                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement='bottom'
                        overlay={
                            <Popover id='library'>
                                <Popover.Title as="h3">Pattern Library</Popover.Title>
                                <Popover.Content>
                                    Pattern Library where you can share and view game design patterns.
                                </Popover.Content>
                            </Popover>
                        }
                    >
                    <div>Pattern Library</div>
                    </OverlayTrigger>
                </NavigationItem>
                <NavigationItem link="/PatternLibraryApp/GamesReference"  sideDrawerClosed={props.sideDrawerClosed}>
                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement='bottom'
                        overlay={
                            <Popover id='reference'>
                                <Popover.Title as="h3">Games Reference</Popover.Title>
                                <Popover.Content>
                                    Details on thousands of games and the patterns they use.
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <div>Games Reference</div>
                    </OverlayTrigger>
                </NavigationItem>
                <NavigationItem link="/PatternLibraryApp/PatternExercises/1"  sideDrawerClosed={props.sideDrawerClosed}>
                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement='bottom'
                        overlay={
                            <Popover id='exercises'>
                                <Popover.Title as="h3">Pattern Exercises</Popover.Title>
                                <Popover.Content>
                                    Detailed exercises for creating your own game design patterns.
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <div>Pattern Exercises</div>
                    </OverlayTrigger>
                </NavigationItem>
            </ul>
        </div>
        <div className={classes.RightNav}>
            <ul className={classes.NavigationItems+' logout'}>
                {!props.isAuthenticated
                    ? <NavigationItem link="/PatternLibraryApp/auth" doInstead={props.openLogin}>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='bottom'
                            overlay={
                                <Popover id='login'>
                                    <Popover.Title as="h3">Login</Popover.Title>
                                    <Popover.Content>Click here to go to the Login / Register page.</Popover.Content>
                                </Popover>
                            }
                        >
                            <div style={{display: "flex", alignItems: "center", marginBottom: '1px'}}>
                                <div style={{paddingRight: 4, marginTop: -4, fontWeight: "bold", fontSize: 18, color: '#006600'}}>Login</div>
                                <img className={classes.Login}
                                     src="https://patternlanguageforgamedesign.com/PatternLibrary/Images/Login.png"
                                     alt="Login"/>
                            </div>
                        </OverlayTrigger>
                      </NavigationItem>
                    : <>
                        <div style={{marginTop: -8, paddingRight: 12, flexDirection: "row", gap: 10, display: "flex"}}>
                            <NotificationsButton token={props.token} userId={props.userId} isAuthenticated={props.isAuthenticated} openNotifications={props.openNotifications} notifications={props.notifications} isInToolbar={props.isInToolbar}/>
                            <UserButton userId={props.userId} userEditOpen={props.userEditOpen} userClicked={props.userClicked} sideDrawerClosed={props.sideDrawerClosed} isInNavbar/>
                            <MiscSearchButton userId={props.userId} accountId={props.accountId} openMiscSearch={props.openMiscSearch}/>
                        </div>
                        <NavigationItem link="/PatternLibraryApp/logout">
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement='bottom'
                            overlay={
                                <Popover id='logout'>
                                    <Popover.Title as="h3">Logout</Popover.Title>
                                    <Popover.Content>Click here to Logout</Popover.Content>
                                </Popover>
                            }
                        >
                            <img className={classes.Logout} src="https://patternlanguageforgamedesign.com/PatternLibrary/Images/Logout.png" alt="Logout" />
                        </OverlayTrigger>

                    </NavigationItem>
                    </>}
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement='bottom'
                    overlay={
                        (props.location.includes('PatternLibraryApp/PatternLibrary')) ?
                            <Popover id='search'>
                                <Popover.Title as="h3">Pattern Search</Popover.Title>
                                <Popover.Content>Click here to open the Pattern Search panel and search for patterns by Title, Keywords, and more.</Popover.Content>
                            </Popover> :
                            <Popover id='search'>
                                <Popover.Title as="h3">Games Search</Popover.Title>
                                <Popover.Content>Click here to open the Game Search panel and search for games by Name, Release Date, and more.</Popover.Content>
                            </Popover>

                    }
                >
                    {
                        (props.location.includes('PatternLibraryApp/PatternLibrary')) ?
                            <div className={classes.SearchLink+' '+classes.clickable} onClick={() => { props.sideDrawerClosed(); props.toggleSearch();}}>
                                <SearchIcon />
                            </div> :
                            <div className={classes.SearchLink + ' ' + classes.clickable} onClick={() => {props.sideDrawerClosed(); props.toggleGamesSearch();}}>
                                <SearchIcon/>
                            </div>
                    }

                </OverlayTrigger>
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement='bottom'
                    overlay={
                        <Popover id='help'>
                            <Popover.Title as="h3">Help!</Popover.Title>
                            <Popover.Content>Click here for a popup full of useful advice and links to help articles.</Popover.Content>
                        </Popover>
                    }
                >
                    <div className={classes.SearchLink+' '+classes.clickable} onClick={() => {props.sideDrawerClosed(); props.toggleHelp();}}>
                        ?
                    </div>
                </OverlayTrigger>

            </ul>
        </div>
    </>
);

export default navigationItems;